import { useLayoutEffect, useRef, useState } from 'react'

import { getElementFontSize } from '../utils/getElementFontSize'
import { scaleFontSizeToContainer } from '../utils/scaleFontSizeToContainer'

export const useScaleFontSizes = (withScaling: boolean) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const valueRef = useRef<HTMLDivElement>(null)
  const currencyRef = useRef<HTMLDivElement>(null)

  const [dimensions, setDimensions] = useState({ containerWidth: 0, textWidth: 0 })
  const [originalSizes, setOriginalSizes] = useState({ value: 0, currency: 0 })

  useLayoutEffect(() => {
    if (!withScaling) {
      return
    }

    const updateMetrics = () => {
      if (containerRef.current && valueRef.current && currencyRef.current) {
        const containerWidth = containerRef.current.offsetWidth
        const textWidth = valueRef.current.offsetWidth + currencyRef.current.offsetWidth
        const valueSize = getElementFontSize(valueRef.current)
        const currencySize = getElementFontSize(currencyRef.current)

        setDimensions({ containerWidth, textWidth })
        setOriginalSizes({ value: valueSize, currency: currencySize })
      }
    }

    const observer = new ResizeObserver(() => {
      requestAnimationFrame(updateMetrics)
    })

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    updateMetrics()

    return () => observer.disconnect()
  }, [withScaling])

  const valueFontSize = withScaling
    ? scaleFontSizeToContainer(originalSizes.value, dimensions.containerWidth, dimensions.textWidth)
    : undefined

  const currencyFontSize = withScaling
    ? scaleFontSizeToContainer(originalSizes.currency, dimensions.containerWidth, dimensions.textWidth)
    : undefined

  return { valueFontSize, currencyFontSize, containerRef, valueRef, currencyRef }
}
